import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from './PageLayout';
import PageMeta from './PageMeta';
import '../styles/_global.css';

export default function NotFoundPage() {
  return (
    <PageLayout mainClassName="not-found-page" meta={<PageMeta title="Page not found" />}>
      <h1>Page not found</h1>
      <p>The page you're looking for doesn't exist or may have moved.</p>
      <Link to="/" className="btn btn-primary">Back to home</Link>
    </PageLayout>
  );
}
